export const BaseUrl = `https://asd-final-project-soat.vercel.app/api/v1`;

export const SIGNUPPARENT = `auth/singupForParent`;
export const SIGNINFORDOCTOR = "auth/singupForDoctor";

export const LOGIN = `auth/login`;

export const VERIFYEMAIL = "auth/verifyemail";

export const FORGETPASSWORD = "auth/forgotPassword";

export const CREATEPARENT = "parents";

export const GETCHILDFORUSER = "childs";

export const FINALPREDICTION = "ai/finalPredication";

export const DEGREEAI = "ai/finalPredication_degree";

export const CHATBOT = "ai/chat";

export const GETAllDOCTORS = "doctors";

export const GETALLMEDICAN = "medican";

export const ARTICLES = "articles";

export const CHARITES = "charities";

export const GETHESTORYAUTISM = "ai/autism_history";

export const GETALLDOCTORSFORSPECIFICUSER = "appointment/my_doctor";

export const CREATEDATETIMEDOCTOR = "appointment/createAppointment";
